import { render, staticRenderFns } from "./PopoverPanelUser.vue?vue&type=template&id=51ebe6b1&scoped=true&"
import script from "./PopoverPanelUser.vue?vue&type=script&lang=ts&"
export * from "./PopoverPanelUser.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverPanelUser.vue?vue&type=style&index=0&id=51ebe6b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ebe6b1",
  null
  
)

export default component.exports